import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import ConvertToString, { getClassName } from "../../../components/Converter";
import RenderFor, { BM_TYP } from "../../../components/RenderFor";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";
import { decimalSeparator, thousandSeparator } from "../../../i18n";
import {
  selectTeilsicherheitsbeiwert,
  setTeilsicherheitsbeiwert,
} from "../../../store/slices/aeussereSlice";

export function TeilsicherheitsbeiwertAeussere({}) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const partialSafetyfactor = useSelector(selectTeilsicherheitsbeiwert);

  return (
    <RowBody
      titleValue={<p>{t("aeussre.partialSafetyFactor")}</p>}
      indicesValue={
        <span>
          &gamma;<sub>s</sub>
        </span>
      }
      inputValue={
        <>
          <RenderFor types={[BM_TYP.EUROCODE_7]}>
            <NumberFormat
              className={getClassName(partialSafetyfactor)}
              value={partialSafetyfactor}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              displayType="input"
              type="text"
              onValueChange={(value) => {
                dispatch(setTeilsicherheitsbeiwert(value.floatValue));
              }}
              allowNegative={true}
            />
          </RenderFor>

          <RenderFor types={[BM_TYP.GERMANY]}>
            <span className="input">{ConvertToString(partialSafetyfactor)}</span>
          </RenderFor>
        </>
      }
      formulaValue={
        <>
          <RenderFor types={[BM_TYP.GERMANY]}>
            <ToolTip
              id={"PartialSafetyFactor"}
              type={IconType.InfoIcon}
              text={t("aeussre.partialSafetyFactorInfo")}
            />
          </RenderFor>
        </>
      }
    />
  );
}
